/**
 * Which slice of the engagement's config history a workflow page is about (MPN-1334).
 *
 * One snapshot per engagement, filtered on read: the header's Versions button renders the same
 * drawer everywhere and scopes itself to the page you are standing on, rather than each page
 * carrying its own history button. A tab with no entry here shows the whole timeline, which is
 * what the overview should do.
 *
 * The strings are the sections the server's `engagement_label` emits, pinned by
 * `test_the_section_vocabulary_is_fixed` — a mismatch renders an empty drawer with no error.
 */
export const SECTIONS_BY_SLUG: Record<string, string[]> = {
  schedule: ["Schedule"],
  budget: ["Budget"],
  "budget-2": ["Budget"],
  campaign: ["Campaign", "Networks"],
  setup: ["Campaign", "Networks"], // old bookmark for the pre-split Setup step
  "ad-groups": ["Ad Groups", "Ads"],
  audience: ["Audience"],
  content: ["Ads"],
  contract: ["Engagement"],
};

/** Human name for the scope, for the drawer's heading. */
export const SECTION_SCOPE_LABEL: Record<string, string> = {
  schedule: "Schedule",
  budget: "Budget",
  "budget-2": "Budget",
  campaign: "Campaign",
  setup: "Campaign",
  "ad-groups": "Ad group",
  audience: "Audience",
  content: "Ad",
  contract: "Engagement",
};

export function sectionsForSlug(slug: string | undefined): string[] | undefined {
  return slug ? SECTIONS_BY_SLUG[slug] : undefined;
}

export function scopeLabelForSlug(slug: string | undefined): string | undefined {
  return slug ? SECTION_SCOPE_LABEL[slug] : undefined;
}
